import { render, staticRenderFns } from "./GlideCarousel.vue?vue&type=template&id=94c49248&scoped=true"
import script from "./GlideCarousel.vue?vue&type=script&lang=ts"
export * from "./GlideCarousel.vue?vue&type=script&lang=ts"
import style0 from "./GlideCarousel.vue?vue&type=style&index=0&id=94c49248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c49248",
  null
  
)

export default component.exports